import { createStaticField } from 'components';
import { BlockStatusTemplate } from './types';

export const BlockStatusTemplateField = createStaticField('campaign/statuses/', {
  getOptionLabel: (a: BlockStatusTemplate) => a.name,
  getOptionValue: (a: BlockStatusTemplate) => a.id.toString(),
});
